export const apiUrl = import.meta.env.VITE_API_URL || 'http://localhost:3000';
export const landingPageUrl = import.meta.env.VITE_LANDING_PAGE_URL || 'https://sofi.coop/chatbot';

export const DEBOUNCE_DELAY = 500;

// Time
export const MILLISECOND = 1;
export const SECOND = 1000 * MILLISECOND;
export const MINUTE = 60 * SECOND;

// Tan Stack Query
export const USE_QUERY_STALE_TIME = 5 * MINUTE;

export const ADMIN_SETTINGS_KEY = 'ADMIN_SETTINGS_KEY';
export const CHATBOT_KEY = 'CHATBOT_KEY';
export const CONVERSATION_LIST_KEY = 'CONVERSATION_LIST_KEY';
export const CHAT_METADATA_KEY = 'CHAT_METADATA_KEY';

export const MAX_TOOL_OUTPUT = 200 as const;
